import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import { FOOTER_ITEMS } from '../../../scripts/navigationItems';

/**
 * List of languages for the footer, in order, where "label" is the display
 *  and the "language" prop is the hash link to a specific language section
 *  within the page. They are in the order they should be displayed.
 */
const LanguageServices = [
	{ label: 'Español-Spanish', language: 'es' },
	{ label: '中文', language: 'ch' }, // 繁體中文
	{ label: 'Tiếng Việt', language: 'vi' },
	{ label: '한국어', language: 'ko' },
	{ label: 'Tagalog', language: 'ta' },
	{ label: 'Pусский', language: '' },
	{ label: 'العربية', language: 'ar' },
	{ label: 'Kreyòl', language: 'kr' }, // Kreyòl Ayisyen
	{ label: 'Français', language: 'fr' },
	{ label: 'Polski', language: 'po' },
	{ label: 'Português', language: 'pt' },
	{ label: 'Italiano', language: 'it' },
	{ label: 'Deutsch', language: 'ge' },
	{ label: '日本語', language: 'ja' },
	{ label: 'فارسی', language: 'pe' },
	{ label: 'Other Languages ...', language: '' },

	/* In page but not in design */
	// { label: 'English', language: 'en' },
	// { label: 'Mien', language: 'ium' },
	// { label: 'हिंदी', language: 'hi' },
	// { label: 'Laotian', language: 'lo' },
	// { label: 'Ukranian', language: 'uk' },
];

const FooterLanguageLinks = props =>
	LanguageServices.map(({ label, language }, length) => (
		<Fragment key={label + language}>
			<Link
				{...props}
				href={`${FOOTER_ITEMS.languageServicesRoot}/${
					language && `#${language}`
				}`}
				target='_blank'
				rel='noreferrer'
				variant='inherit'
				underline='hover'
				sx={{ wordBreak: 'keep-all' }}
			>
				{label}
			</Link>
			{length + 1 < LanguageServices.length && (
				<Typography variant='inherit' color='inherit' component='span'>
					{' '}
					|{' '}
				</Typography>
			)}
		</Fragment>
	));

export default FooterLanguageLinks;
